import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

const tooltip = css`
  > div {
    background-color: ${colors.secondary.default};
    color: ${colors.white};
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    white-space: normal;
    min-width: 180px;
    max-width: 260px;

    ::before {
      border-bottom-color: ${colors.secondary.default};
    }
  }
`;

const layer = (color: string, fill?: string) => css`
  fill: ${fill || color} !important;
  stroke: ${color} !important;
  stroke-width: 3 !important;
`;

export default { tooltip, layer };
